import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { INVALIDATE_WIFI } from 'graphql/service';
import { useMutation } from '@apollo/client';
import colors from 'constants/colors';
import { Container } from './styles';

const ModalInvalidateWifi = ({
  buttonStyle,
  bookingId,
  checkedOut
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
  const [failedIsOpen, setFailedIsOpen] = useState(false)

  const [invalidateWifi, { loading }] = useMutation(INVALIDATE_WIFI, {
    onCompleted: () => {
      setSuccessfullyIsOpen(true)
      setFailedIsOpen(false)
      setIsOpen(false)
    },
    onError: (error) => {
      setFailedIsOpen(true)
      setIsOpen(false)
    }
  })

  const handleSubmit = () => {
    if(loading) return
    invalidateWifi({
      variables: {
        input: {
          bookingId: bookingId,
          reason: checkedOut? "CHECKOUT": "CANCELLATION"
        }
      }
    })
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Invalidate Wi-Fi"
        buttonStyle={buttonStyle}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              position: relative;
              height: 100%;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>Are you sure you want to invalidate the current Wi-Fi credentials? This action will immediately revoke access for anyone using the existing credentials.</div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
              `}
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleSubmit}
              data-loading={loading}
              additionalstyle={`
                width: 192px;
              `} 
            >
              {loading? null: 'Invalidate Credentials'}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        type='invalidate-wifi'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleSubmit}
        type='invalidate-wifi'
      />
    </>
  );
}

export default ModalInvalidateWifi;
